import { render, staticRenderFns } from "./ConceptEmail.vue?vue&type=template&id=7970614e&"
import script from "./ConceptEmail.vue?vue&type=script&lang=js&"
export * from "./ConceptEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports